import { envTypeGet } from "../common";
import { API_TYPES } from "./api_constants";

export type UrlBases = {
  auth: string;
  unosRad: string;
};

export type ApiType = "auth" | "unosRad";

export const apiUrlBasesGet = (): UrlBases => {
  const envType = envTypeGet();
  let urlBases = {
    unosRad: "http://localhost:3011/api/v1",
    auth: "http://localhost:3012/api/v1",
  };
  if (envType === "production") {
    urlBases = {
      unosRad: "https://unos-rad.emlearn.info/api/unos/v1",
      auth: "https://unos-rad.emlearn.info/api/auth-unos/v1",
    };
  }

  return urlBases;
};

export const apiTypeUrlBaseGet = (apiType: string): string => {
  const urlBases: UrlBases = apiUrlBasesGet();
  const url = urlBases[apiType as ApiType];
  return url;
};

export const apiTypeUrlGet = (apiType: string, path: string): string => {
  const urlBase: string = apiTypeUrlBaseGet(apiType);
  const url = urlBase + "/" + path;
  return url;
};

export const apiAuthUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.AUTH, path);
  return url;
};

export const apiUnosUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.UNOS, path);
  return url;
};
